import manifest_45route_45rule from "/codebuild/output/src1514297341/src/nordvaerk-box-site/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}